import { normalizeGeneratedAsset } from '@/lib/generation/normalize-generated-asset';

const normalizeImageBase64Result = (value, fallbackMimeType = 'image/png') => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('data:')) return trimmed;
  return `data:${fallbackMimeType};base64,${trimmed}`;
};

const buildAdditionalInfo = (data = {}) => {
  return {
    ...(data.additionalInfo || {}),
    imageId: data.imageId,
    provider: data.provider,
  };
};

const buildAssetResult = (assetUrl, data) => {
  return {
    assetUrl,
    additionalInfo: buildAdditionalInfo(data),
  };
};

export function buildImageGenerationResult(data) {
  if (data?.data?.[0]?.url) {
    return buildAssetResult(normalizeGeneratedAsset(data.data[0].url), data);
  }

  if (data?.url) {
    return buildAssetResult(normalizeGeneratedAsset(data.url), data);
  }

  const normalizedBase64 = normalizeImageBase64Result(
    data?.data?.[0]?.b64_json,
    data?.data?.[0]?.mime_type || data?.data?.[0]?.mimeType || 'image/png',
  );
  if (normalizedBase64) {
    return buildAssetResult(normalizedBase64, data);
  }

  if (typeof data?.data === 'string') {
    return buildAssetResult(normalizeGeneratedAsset(data.data), data);
  }

  return null;
}
